const config = {
    API_BASE_URL: "https://api.cornleth.com/api/",
    API_BASE_URL_V1: "https://api.cornleth.com/api/v1/",
    // API_BASE_URL: "https://api.viarw.com/api/",
    // API_BASE_URL_V1: "https://api.viarw.com/api/v1/",
    //API_BASE_URL: "https://b2b-laravel.test/api/",
    //API_BASE_URL_V1: "https://b2b-laravel.test/api/v1/",
    API_KEY: "AIzaSyAiWeHzXqK0qgDMvtHbmom9tOmXpolhcPc",
    GOOGLE_MAPS_API_KEY: "AIzaSyAiWeHzXqK0qgDMvtHbmom9tOmXpolhcPc", // Google Maps API Key
};

export default config;
